export default __webpack_public_path__ + "static/media/American1.7447a8e8.jpg";